import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
    palette: {
        primary: {
            main: "#23932e",
        },
        secondary: {
           main: "#ECECEC",
        }
    }
});

export default theme;